const trustCards = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    label: "Bezpieczne zakupy",
  },
  {
    id: 2,
    icon: "ri-truck-line",
    label: "Szybka wysyłka",
  },
  {
    id: 3,
    icon: "ri-price-tag-3-line",
    label: "Niskie ceny",
  },
  {
    id: 4,
    icon: "ri-bank-card-line",
    label: "Bezpieczne płatności",
  },
  {
    id: 5,
    icon: "ri-customer-service-2-line",
    label: "Wsparcie klienta",
  },
];

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-foreground-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-400 mb-6">
          TRUSTED SHOPPING GUIDE
        </span>

        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-12 leading-tight">
          Najlepszy
          <br />
          Kakobuy
          <br />
          Spreadsheet Polska
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="bg-background-50 text-foreground-900 px-7 py-3 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Odwiedź główną stronę
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="border border-background-50/30 text-background-50 px-7 py-3 rounded-full text-sm font-semibold hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zobacz ofertę
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
          {trustCards.map((card) => (
            <div
              key={card.id}
              className="bg-foreground-800/60 rounded-2xl p-5 md:p-6 flex flex-col items-center gap-3"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${card.icon} text-2xl text-background-50`}></i>
              </div>
              <span className="text-sm text-background-50/80 font-medium whitespace-nowrap">{card.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}